import * as React from 'react';

const Title = ({ children, large = false }) => (
  <div className={`title${large ? ' is-1' : ''}`}>{children}</div>
);

export default Title;
